import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { stringify as stringifyParams } from 'hub-http/helpers/params';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { getModulesStorefrontRoute, getThemesStorefrontRoute } from '../../utils/urls';
import { useRouteOfferingType } from '../hooks/useRouteOfferingType';
import { getQueryFieldUrl } from '../utils/assetQuery';
export default function RouterFilterButton(_ref) {
  let {
    queryField,
    value
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["queryField", "value"]);

  const offeringType = useRouteOfferingType();
  const getRoute = useCallback((path, paramsString = '') => {
    return offeringType === 'MODULE' ? path ? getModulesStorefrontRoute(path) : `${getModulesStorefrontRoute()}?${paramsString}` : path ? getThemesStorefrontRoute(path) : `${getThemesStorefrontRoute('all')}?${paramsString}`;
  }, [offeringType]);
  const computedLocation = useMemo(() => {
    const paramsString = stringifyParams({
      [`eco_${queryField}`]: value
    });
    let path;

    if (Array.isArray(value) && value.length === 1) {
      path = getQueryFieldUrl(queryField, value[0]);
    } else if (typeof value === 'string') {
      path = getQueryFieldUrl(queryField, value);
    }

    return getRoute(path, paramsString);
  }, [getRoute, queryField, value]);
  return /*#__PURE__*/_jsx(UIRouterButton, Object.assign({}, rest, {
    to: computedLocation
  }));
}